<template>
    <div :class="['input-error', { 'text-center': centered }]">
        <div class="svg">
            <!-- TODO material icons -->
            <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.633333 10.0016C0.526389 10.0016 0.434028 9.97726 0.35625 9.92865C0.278472 9.88003 0.215278 9.81684 0.166667 9.73906C0.118056 9.66128 0.0937501 9.57378 0.0937501 9.47656C0.103472 9.37934 0.132639 9.28698 0.18125 9.19948L5.54792 0.245311C5.59653 0.157812 5.65972 0.0946174 5.7375 0.0557286C5.825 0.0168397 5.9125 -0.00260472 6 -0.00260472C6.0875 -0.00260472 6.17014 0.0168397 6.24792 0.0557286C6.33542 0.0946174 6.40347 0.157812 6.45208 0.245311L11.8188 9.19948C11.8674 9.28698 11.8917 9.37934 11.8917 9.47656C11.9014 9.57378 11.8819 9.66128 11.8333 9.73906C11.7847 9.81684 11.7215 9.88003 11.6438 9.92865C11.566 9.97726 11.4736 10.0016 11.3667 10.0016H0.633333ZM1.55208 8.95156H10.4479L6 1.54323L1.55208 8.95156ZM6 8.25156C6.14583 8.25156 6.26736 8.20295 6.36458 8.10573C6.47153 7.99878 6.525 7.8724 6.525 7.72656C6.525 7.58073 6.47153 7.4592 6.36458 7.36198C6.26736 7.25503 6.14583 7.20156 6 7.20156C5.85417 7.20156 5.72778 7.25503 5.62083 7.36198C5.52361 7.4592 5.475 7.58073 5.475 7.72656C5.475 7.8724 5.52361 7.99878 5.62083 8.10573C5.72778 8.20295 5.85417 8.25156 6 8.25156ZM6 6.50156C6.14583 6.50156 6.26736 6.45295 6.36458 6.35573C6.47153 6.24878 6.525 6.1224 6.525 5.97656V4.22656C6.525 4.08073 6.47153 3.9592 6.36458 3.86198C6.26736 3.75503 6.14583 3.70156 6 3.70156C5.85417 3.70156 5.72778 3.75503 5.62083 3.86198C5.52361 3.9592 5.475 4.08073 5.475 4.22656V5.97656C5.475 6.1224 5.52361 6.24878 5.62083 6.35573C5.72778 6.45295 5.85417 6.50156 6 6.50156Z" fill="#FF3E57"/>
            </svg>
        </div>
        <div class="error" v-html="error"></div>
    </div>
</template>

<script>
    export default {
        props: {
            error: {
                type: String,
                required: false
            },
            centered: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {}
        }
    }
</script>
